// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 557 ? "f10664bc" : chunkId) + "." + {"212":"51a0f54e5b7699e8","505":"78af71967b35bf9e","557":"21b08f01028e7219"}[chunkId] + ".js";
};